import React from 'react';
import { useSearchParams } from 'react-router-dom';
import IELTSCourse from '../courses/IELTSCourse';
import { subjectVerbAgreementData, getDataForDifficulty } from '../courses/data/grammar/subjectVerbAgreement';

export default function SubjectVerbAgreementTips() {
  const [searchParams] = useSearchParams();
  const lessonId = searchParams.get('lessonId');
  const difficulty = parseInt(searchParams.get('difficulty')) || 3;

  return (
    <IELTSCourse
      {...(difficulty !== 3 ? getDataForDifficulty(difficulty) : subjectVerbAgreementData)}
      lessonId={lessonId}
      difficulty={difficulty}
    />
  );
}
